import { render, staticRenderFns } from "./LvLawPick.vue?vue&type=template&id=2517633c"
import script from "./LvLawPick.vue?vue&type=script&lang=js"
export * from "./LvLawPick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports